import {
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import {
  LastIdPaginationFactory,
  MobileDetectService,
  RouterService,
  UserModel,
  UserService,
} from '@lib/gc-common';

@Component({
  selector: 'mip-profile-info',
  templateUrl: './profile-info.component.html',
  styleUrls: ['./profile-info.component.scss'],
})
export class ProfileInfoComponent implements OnInit, OnDestroy {
  profile: UserModel = null;

  followersCount = 0;
  followingCount = 0;

  followers: Array<UserModel> = [];
  following: Array<UserModel> = [];

  loadingFollowers = true;
  loadingFollowing = true;

  followersPagination: LastIdPaginationFactory = null;
  followingPagination: LastIdPaginationFactory = null;

  activeTab = 0;
  tabs = ['followers', 'following'];

  isMobile = true;
  isDesktop = false;

  onRouteChangeSubscription = null;

  constructor(
    private userService: UserService,
    private routerService: RouterService,
    private mobileDetect: MobileDetectService,
  ) {
    this.isMobile = this.mobileDetect.isMobile();
    this.isDesktop = !this.mobileDetect.isMobile();
  }

  async ngOnInit() {
    try {
      this.onRouteChangeSubscription = this.routerService.onRouteChange().subscribe(async ({ params }) => {
        // console.log('profile-info.component->ngOnInit(): params', params);

        if (params.tab) {
          this.activeTab = this.tabs.indexOf(params.tab);
        }

        if (params.userId) {
          if (!this.profile) {
            this.profile = await this.userService.getUser(params.userId);
            // console.log('profile-info.component->ngOnInit(): this.profile', this.profile);

            this.followersCount = this.profile.userStats.followers;
            this.followingCount = this.profile.userStats.following;
          }

          if (this.activeTab === 0 && this.followers.length === 0) {
            this.followersPagination = new LastIdPaginationFactory(
              this.profile.getUserFollowers.bind(this.profile),
              this.followers,
              { limit: 30 },
              'profile-info.component',
            );
            this.getMoreFollowers();
          }

          if (this.activeTab === 1 && this.following.length === 0) {
            this.followingPagination = new LastIdPaginationFactory(
              this.profile.getUserFollowing.bind(this.profile),
              this.following,
              { limit: 30 },
              'profile-info.component',
            );
            this.getMoreFollowing();
          }
        }
      });
    } catch (e) {
      throw e;
    }
  }

  ngOnDestroy() {
    if (this.followersPagination) {
      this.followersPagination.destroy();
    }
    if (this.followingPagination) {
      this.followingPagination.destroy();
    }
    if (this.onRouteChangeSubscription) {
      this.onRouteChangeSubscription.unsubscribe();
    }
  }

  /**
   * Method to get more followers
   */
  async getMoreFollowers() {
    try {
      // console.log('profile-followers.component->getMoreFollowers()');

      this.loadingFollowers = true;

      await this.followersPagination.getItems();

      this.followersCount = this.followersPagination.totalCount;
      // console.log('profile-followers.component->getMoreFollowers(): this.followersCount', this.followersCount);

      // console.log('profile-followers.component->getMoreFollowers(): this.followers', this.followers);

      this.loadingFollowers = false;
    } catch (e) {
      throw e;
    }
  }

  /**
   * Method to get more following
   */
  async getMoreFollowing() {
    try {
      // console.log('profile-followers.component->getMoreFollowing()');

      this.loadingFollowing = true;

      await this.followingPagination.getItems();

      this.followingCount = this.followingPagination.totalCount;
      // console.log('profile-followers.component->getMoreFollowing(): this.followingCount', this.followingCount);

      // console.log('profile-followers.component->getMoreFollowing(): this.following', this.following);

      this.loadingFollowing = false;
    } catch (e) {
      throw e;
    }
  }

  onSelectTab(event) {
    // console.log('profile-following.component->onSelectTab(): event', event);

    const tabName = this.tabs[event.index];
    // console.log('profile-following.component->onSelectTab(): tabName', tabName);

    this.routerService.navigateTo(`/@${this.profile.username}/info/${tabName}`);
  }
}
